import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCrownPro = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.1497 4.43727C12.6226 3.58064 11.3774 3.58065 10.8503 4.43727L7.72117 9.52204L4.11328 7.71809C3.2345 7.2787 2.24502 8.07242 2.48332 9.0256L4.27238 16.1819C4.35585 16.5158 4.65584 16.75 4.99999 16.75H19C19.3441 16.75 19.6441 16.5158 19.7276 16.1819L21.5167 9.0256C21.755 8.07242 20.7655 7.2787 19.8867 7.71809L16.2788 9.52204L13.1497 4.43727ZM8.92667 10.4252L12 5.43101L15.0733 10.4252C15.44 11.021 16.2011 11.238 16.8268 10.9251L19.8769 9.40005L18.4144 15.25H5.58557L4.12309 9.40005L7.17319 10.9251C7.79893 11.238 8.56001 11.021 8.92667 10.4252ZM5.5 17.75C5.08579 17.75 4.75 18.0858 4.75 18.5C4.75 18.9142 5.08579 19.25 5.5 19.25H18.5C18.9142 19.25 19.25 18.9142 19.25 18.5C19.25 18.0858 18.9142 17.75 18.5 17.75H5.5Z",
		fill: "currentColor"
	})
});
export { SvgIconCrownPro as ReactComponent };
